<template>
    <section>
        <h2>{{ label }}</h2>
        <div class="description">
            <span v-html="description"></span>
        </div>
        <div class="notification is-danger" v-if="showError">
            Bitte wählen Sie eine Antwort aus.
        </div>

        <div class="block">
            <div
                v-for="(option, idx) in options"
                :key="idx"
                class="transform-radio"
            >
                <input
                    @change="change($event.target.defaultValue)"
                    type="radio"
                    :id="`${qid}-${idx}`"
                    :value="option != 'SONST' ? idx : -1"
                    v-model="formdata.selected"
                />
                <label :for="`${qid}-${idx}`">
                    {{ option == "SONST" ? "Sonstiges" : option }}
                </label>
            </div>
            <!-- <b-field v-for="(option, idx) in options" :key="idx">
                <b-radio
                    v-model="formdata.selected"
                    :name="qid.toString()"
                    @input="change($event)"
                    :native-value="option != 'SONST' ? idx : -1"
                >
                    {{ option == "SONST" ? "Sonstiges" : option }}
                </b-radio>
            </b-field> -->
        </div>

        <b-field v-if="showSonstiges">
            <b-input
                placeholder="Andere Angabe"
                v-model="formdata.sonstiges"
            ></b-input>
        </b-field>
    </section>
</template>
<script>
export default {
    props: {
        qid: Number,
        label: String,
        description: String,
        placeholder: String,
        options: Array,
        hasSonstiges: Boolean,
        value: Object,
        hasError: Boolean,
    },
    data() {
        return {
            showSonstiges: false,
            showError: this.hasError,
            formdata: this.value || {
                selected: null,
                sonstiges: "",
            },
        };
    },
    watch: {
        hasError(v) {
            this.showError = v;
        },
    },
    methods: {
        change(evt) {
            this.showError = false;
            if (evt == -1) {
                this.showSonstiges = true;
            } else {
                this.showSonstiges = false;
            }
            this.$emit("input", this.formdata);
        },
    },
};
</script>
<style style="scss">
.transform-radio label {
    margin-left: 10px !important;
    position: relative;
    top: -1px;
}
@media only screen and (max-width: 400px) {
    .transform-radio label {
        font-size: 13px;
    }   
}
.transform-radio {
    margin-bottom: 8px;
}
.transform-radio input[type="radio"] {
    transform: scale(1.3);
}
</style>
